const QUERY_STRING_IGNORE_METADATA = "query-string-ignore";

export function QueryStringIgnore(target: any, propertyKey: string | symbol): any {
    Reflect.defineMetadata(QUERY_STRING_IGNORE_METADATA, true, target, propertyKey);
}

export function isDecoratedWithQueryStringIgnore(target: any, propertyKey: string | symbol): boolean {
    return Reflect.getMetadata(QUERY_STRING_IGNORE_METADATA, target, propertyKey) === true;
}
